<label *ngIf="label" class="control-label">{{ label }}</label>

<select
  class="form-control"
  (change)="onChange($event, selectElement)"
  #selectElement
>
  <option [value]="'null'"></option>
  <option *ngFor="let option of options" [value]="getItemValue(option)" [title]="getTooltipValue(option)">
    {{ getDisplayValue(option) }}
  </option>
</select>

<span *ngIf="selectedItems && selectedItems.length > 0">
  <span
    *ngFor="let item of selectedItems"
    class="badge badge-secondary mr-1"
    (mouseenter)="setTagActiveMapValue(item, true)"
    (mouseleave)="setTagActiveMapValue(item, false)"
  >
    {{ getDisplayValueFromItemValue(item) }}
    <a
      href="#"
      class="bg-secondary text-light"
      (click)="removeItem(item, $event)"
      *ngIf="isTagActive(item)"
    >
      <fa-icon [icon]="removeIcon"></fa-icon>
    </a>
  </span>
</span>
